import { type UserInfo, type UserType } from '@/types';

import { normalizeStoredWorkspace } from './mapWorkspaceDetail';

/**
 * 복원한 `type` 을 소문자로 접는다. 예전 배포가 저장한 JSON 에는 대문자(`STUDENT`)가 남아
 * 있어 `user.type === 'student'` 분기가 조용히 빗나간다.
 */
const normalizeStoredUserType = (type: UserInfo['type']) =>
  typeof type === 'string' ? (type.toLowerCase() as UserType) : type;

/**
 * `quiz_user`(localStorage) 에서 복원한 값을 보정한다. idempotent.
 *
 * 저장소는 스키마 검증도 마이그레이션도 없어서 예전 배포가 남긴 JSON 이 그대로 돌아온다.
 * `workspace` 가 빠진 페이로드로 부팅한 사용자가 전역 CRM 동기화에서 크래시했다(QUIZ-APP-7YB).
 * 필드 존재를 보장하고, 값 포맷이 바뀐 이력이 있는 필드만 골라 정규화한다.
 */
export const normalizeStoredUser = (
  user: UserInfo | null | undefined,
): UserInfo | null =>
  user
    ? {
        ...user,
        type: normalizeStoredUserType(user.type),
        workspace: normalizeStoredWorkspace(user.workspace),
      }
    : null;
